var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlertDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 21.3326H16.0104M15.9997 13.3326V17.3326M14.0997 6.95531L4.68908 22.666C4.49518 23.002 4.39263 23.383 4.39161 23.7709C4.39059 24.1589 4.49114 24.5404 4.68327 24.8775C4.87539 25.2145 5.1524 25.4954 5.48674 25.6922C5.82109 25.889 6.20113 25.9949 6.58908 25.9993H25.4104C25.7985 25.9953 26.1788 25.8897 26.5134 25.693C26.848 25.4963 27.1252 25.2153 27.3174 24.8781C27.5096 24.5409 27.6101 24.1592 27.6088 23.7711C27.6076 23.383 27.5047 23.002 27.3104 22.666L17.9011 6.95531C17.7032 6.62855 17.4243 6.35835 17.0915 6.17082C16.7587 5.98329 16.3831 5.88477 16.0011 5.88477C15.6191 5.88477 15.2435 5.98329 14.9107 6.17082C14.5778 6.35835 14.299 6.62855 14.1011 6.95531",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertDark);
export default __webpack_public_path__ + "static/media/ic-alert-dark.52e94acae5fdd95932c14e6838580788.svg";
export { ForwardRef as ReactComponent };